export default {
    SAVE_INTERVALS_SETTINGS: "saveIntervals",
    INIT_INTERVALS_SETTINGS: "initIntervals",
    SAVE_SAVED_SETTINGS: "saveSavedSettings",
    SAVE_CURRENCY: "saveCurrency",
    SAVE_DATE: "saveDate",
    ADD_TO_SELECTED: "addToSelected",
    REMOVE_FROM_SELECTED: "removeFromSelected",
    DELETE_ALL_SELECTED: "deleteAllSelected",
};